<template>
  <div class="container mx-auto">
    <div class="w-full max-w-2xl mx-auto" v-if="form_status == 0">
      <form
        class="bg-white sm:shadow-md sm:rounded px-4 sm:px-8 pt-6 pb-2 sm:pb-8 mb-2 mt-2 sm:mb-4"
        @submit="on_form_submit"
        ref="entrance_form"
      >
        <div class="block text-gray-600 text-sm">
          Please enter your information to visit our virtual booth.
        </div>
        <br />
        <div class="grid grid-cols-2 gap-3">
          <template v-for="item in form_model">
            <SimpleTextField
              :id="item.id"
              :label="item.label"
              v-model="item.value"
              :extra_field_class="item.extra_class"
              :type="item.type"
              v-if="item.type == 'text'"
              :key="item.id"
              :required="item.required"
            />
          </template>
        </div>
        <div class="text-xs py-4 text-center">
          By clicking 'submit', I hereby authorize CVS Health ('CVS') to use and
          disclose my email address for purposes of sending me emails about the
          services of CVS Health and its affiliated pharmacies. I may opt-out of
          receiving these email communications at any time by clicking on the
          unsubscribe link in the email.
          <br />
          <a
            class="text-default-btn-color hover:text-default-btn-color-hover underline"
            href="https://cvshealth.com/privacy-policy"
            target="_blank"
            >Privacy Policy</a
          >
        </div>

        <div
          class="flex items-center justify-around flex-col sm:flex-row flex-grow"
          v-if="app_type == 'desktop'"
        >
          <button
            class="bg-default-btn-color hover:bg-default-btn-color-hover text-white font-bold py-3 sm:py-2 px-10 rounded focus:outline-none focus:shadow-outline w-full my-1 sm:mx-2"
            type="button"
            @click="do_submit($event, 'FREE')"
          >
            SUBMIT
          </button>
        </div>

        <div
          class="flex items-center justify-around flex-col sm:flex-row flex-grow"
          v-if="app_type == 'mobile'"
        >
          <button
            class="bg-default-btn-color hover:default-btn-color-hover text-white font-bold py-3 sm:py-2 rounded focus:outline-none focus:shadow-outline w-full my-1"
            type="button"
            @click="do_submit($event, 'SIMPLE')"
          >
            SUBMIT
          </button>
        </div>
      </form>
      <p class="text-center text-gray-500 text-xs">
        Powered by ProtoExpo
      </p>
    </div>
    <div
      class="w-full max-w-lg mx-auto loading-app"
      v-if="show_loading && app_type == 'desktop'"
    >
      <img src="../assets/loading.svg" />
      <span :class="load_percentage_class">{{ load_percentage }}%</span
      >&nbsp;&nbsp; LOADING, PLEASE WAIT
    </div>

    <div
      class="w-full max-w-lg mx-auto loading-app"
      v-if="show_loading && app_type == 'mobile'"
    >
      <img src="../assets/loading.svg" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import SimpleTextField from "./form/SimpleTextField";
export default {
  name: "BoothForm",
  components: {
    SimpleTextField
  },
  data() {
    return {
      form: {
        name: "",
        last_name: "",
        company: "",
        title: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        email: "",
        phone: "",
        request_meeting: ""
      },
      form_model: [
        {
          id: "name",
          type: "text",
          required: true,
          label: "First Name",
          value: "",
          extra_class: "",
          validation: ["notempty"]
        },
        {
          id: "last_name",
          type: "text",
          required: true,
          label: "Last Name",
          value: "",
          extra_class: "",
          validation: ["notempty"]
        },
        {
          id: "company",
          type: "text",
          required: false,
          label: "Company",
          value: "",
          extra_class: "",
          validation: []
        },
        {
          id: "title",
          type: "text",
          required: false,
          label: "Title",
          value: "",
          extra_class: "",
          validation: []
        },
        {
          id: "address",
          type: "text",
          required: true,
          label: "Address",
          value: "",
          extra_class: "",
          validation: ["notempty"]
        },
        {
          id: "city",
          type: "text",
          required: true,
          label: "City",
          value: "",
          extra_class: "",
          validation: ["notempty"]
        },
        {
          id: "state",
          type: "text",
          required: true,
          label: "State",
          value: "",
          extra_class: "",
          validation: ["notempty"]
        },
        {
          id: "zip",
          type: "text",
          required: true,
          label: "Zip",
          value: "",
          extra_class: "",
          validation: ["notempty"]
        },
        {
          id: "email",
          type: "text",
          required: true,
          label: "Email",
          value: "",
          extra_class: "",
          validation: ["notempty"]
        },
        {
          id: "phone",
          type: "text",
          required: true,
          label: "Phone",
          value: "",
          extra_class: "",
          validation: ["notempty"]
        },
        {
          id: "request_meeting",
          type: "text",
          required: false,
          label: "Request a meeting",
          value: "",
          extra_class: "",
          validation: []
        }
      ],
      common_field_class:
        "shadow appearance-none border rounded w-full py-1 sm:py-2 px-0 xm:px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-white",
      common_label_class: "block text-gray-700 text-sm font-bold mb-0 sm:mb-2",
      field_container_class: "mb-2 sm:mb-4 md:mb-6 text-left"
    };
  },
  computed: {
    ...mapState(["form_status", "app_type", "app_state", "site_config"]),
    show_loading() {
      return (
        this.$store.state.form_status >= 1 && this.$store.state.app_state < 0
      );
    },
    load_percentage() {
      return Math.round(this.$store.state.unity_progress * 100);
    },
    load_percentage_class() {
      var str =
        "px-4 py-1 text-white font-bold text-sm w-18 rounded-full inline-block transition duration-500 ease-in-out ";
      if (this.load_percentage < 50) {
        str += " bg-gray-400";
      } else if (this.load_percentage < 60) {
        str += " bg-gray-500";
      } else if (this.load_percentage < 70) {
        str += " bg-gray-600";
      } else if (this.load_percentage < 80) {
        str += " bg-gray-800";
      } else if (this.load_percentage < 85) {
        str += " bg-red-300";
      } else if (this.load_percentage < 95) {
        str += " bg-red-400";
      } else {
        str += "bg-red-500";
      }
      return str;
    }
  },
  methods: {
    get_field_class(field) {
      var str = this.common_field_class;
      if ("undefined" != typeof this.form_model[field].extra_class) {
        str += this.form_model[field].extra_class;
      }
      return str;
    },
    on_form_submit(ev) {
      ev.preventDefault();
    },
    do_submit(ev, app_mode) {
      let valid_form = true;

      this.form_model.forEach((item) => {
        let valid_field = true;
        let validation = item.validation;

        validation.forEach((validation_type) => {
          switch (validation_type) {
            case "notempty":
              if (item.value.length <= 0) {
                valid_form = false;
                valid_field = false;
              }

              break;
          }
        });
        if (valid_field) {
          item.extra_class = "";
        } else {
          item.extra_class = " border-red-500 ";
        }
      });

      //for debugging purposes, allow the form to always be valid
      //so we don't need to fill it in all the time
      if (!this.site_config.validate_form) {
        valid_form = true;
      }

      if (!valid_form) {
        return;
      }

      var data_to_submit = { app_mode: app_mode };

      this.form_model.forEach((item) => {
        data_to_submit[item.id] = item.value;
      });
      this.$store.dispatch("submit_form", data_to_submit);

      this.form_model.forEach((item) => {
        item.value = "";
      });
      this.$refs.entrance_form.reset();

      this.$ga.event("intro_form", "app_mode", app_mode, 1);
    },
    open_privacy(e) {
      e.preventDefault();
      this.$store.dispatch("set_popup_state", "privacy");
    }
  },
  mounted() {
    this.$ga.page("/start-form");
  }
};
</script>

<style scoped>
.bg-teal {
  background-color: #00b2aa;
}
.loading-app {
  text-align: center;
  color: #999;
}
.loading-app img {
  display: block;
  width: 150px;
  height: 150px;
  min-width: 150px;
  min-height: 150px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/BoothForm.vue